module.exports = __webpack_public_path__ + "static/media/drive.4c12d795.svg";